import React from 'react';

import { Layout } from '../../Layout/Layout';

interface Props {
  /** Children */
  children: React.ReactNode;
}

export const BaseHeader = ({ children }: Props) => {
  return (
    <Layout align="center" borderBottom="border.divider" px={4} py={3}>
      {children}
    </Layout>
  );
};
